export const SAVE_CONTACT = 'save_contact';
export const FETCH_PORTFOLIOS = 'fetch_portfolio';
export const FILTER_PORTFOLIOS = 'filter_portfolio'

export const PORTFOLIO_FILTER_TYPES = {
  SHOW_ALL: 'SHOW_ALL',
  SHOW_COMPLETED: 'SHOW_COMPLETED',
  SHOW_ACTIVE: 'SHOW_ACTIVE'
}


// WEBPACK FOOTER //
// ./src/actions/types.js